module.exports = __webpack_public_path__ + "media/img/event/profiling_header-a5cbf4fc99cb7d656d0f912130162b46.png";